import React,{useState, useEffect} from 'react'
import {Col, Row} from 'react-bootstrap'
import './Timers.css'
import { activityStyle, Duration } from '../Shared/Formating'
import {Clickable} from '../Shared/ViewControl'
import {Fetch} from '../Api'

const Timers = ({element, activity, onElement, reported=1}) => {
    const entity='Timer'

    const [items, Items] = useState([]);
    const [selected, Select] = useState(element);
    const [loaded, Load] = useState(false);

    useEffect(() => {
        if(!loaded) {
            //console.log('get timer: ', `/${entity}/${element}`, reported)
            Fetch(`${entity}`, null, 2, Load, null, Items)
        }
        else {
            if(items?.length>0){
                //console.info(items); alert(JSON.stringify(items));
                let item = items[0]
                //if (!Object.hasOwn(item, "count_Id")) 
                {
                    let groupItems = aggregateData(items)
                    //console.info('groupItems',groupItems); alert(JSON.stringify(groupItems));
                    Items(groupItems)
                }
                let id=item?.Id ?? 0
                if(id>0) {
                    item.Focused = parseInt(item.Focused)+reported*19
                    Select(id)
                }
            }
        }
    }, [loaded, element])

    const onClick = (id) => {
        Select(id)
    }
 
        return (
            
<Row className="timer-grid">

{ loaded ?
<React.Suspense fallback="Loading..."> 
<h6>{entity}(s)</h6>
    {    
        items.map(item=>
            <Timer key={`timer-${item.Id}`} item={item} selected={selected} onSelect={onClick} onElement={onElement} />
        )
    }
</React.Suspense>   
:
<h6 style={{color:'darkred'}}>{entity}(s) loading...</h6>
}
</Row>
        )

    function aggregateData(data) {
        // Use reduce to iterate over the array and build the grouped result
        const groupedData = data.slice(0, 100).reduce((accumulator, currentItem) => {
            // 1. Create a unique key for grouping
            const key = `${currentItem.Date}_${currentItem.Element}_${currentItem.Activity}`;

            // Ensure 'Focused' is a number before summing (it's a string in your sample)
            const focusedValue = Number(currentItem.Focused ?? 1);

            // If the key doesn't exist in the accumulator, initialize it
            if (!accumulator[key]) {
                accumulator[key] = {
                    Date: currentItem.Date,
                    Element: currentItem.Element,
                    Activity: currentItem.Activity,
                    // Initialize aggregation fields
                    Id: 0,
                    Focused: 0,
                    Times: 0,
                    StartDate: currentItem.StartDate, // Initialize min/max with the current item's values
                    EndDate: currentItem.EndDate,
                    count_Id:0,
                };
            }

            // 2. Perform the aggregation
            const group = accumulator[key];

            group.count_Id += 1;
            group.Id = currentItem.Id;

            // Sum: Add to the Focused and Times totals
            group.Focused += focusedValue;
            group.Times += currentItem.Times;

            // Min: Find the earliest StartDate
            // Assuming StartDate is in HH:MM format, simple string comparison works for min/max
            if (currentItem.StartDate < group.StartDate) {
                group.StartDate = currentItem.StartDate;
            }

            // Max: Find the latest EndDate
            if (currentItem.EndDate > group.EndDate) {
                group.EndDate = currentItem.EndDate;
            }
            return accumulator;
        }, {}); // Start with an empty object {}

        // 3. Convert the object back into an array of results
        return Object.values(groupedData);
    }


}


const Timer = ({item, selected, onSelect, onElement}) => {

    //console.log('<Timer...', item)
    let cstyle= {...activityStyle(item?.Activity)}

    useEffect(() => {

    }, [selected])

    const onClick = (item) => {
        //alert(item.Id)
        onSelect(item.Id)
    }

    return (
        <Col className="timer-cell" style={{...cstyle, border: (selected===item.Id ?'2px solid white':'')}} onClick={()=>onClick(item)}>
            <Row className="align-items-center">
            <Col sm={4} style={{fontSize: '1.2rem'}}>{Duration(item.Focused)}</Col>    
            <Col sm={2} >{item?.Times}</Col>    
            <Col sm={3} title={`Time-${item.Id}`} >{item?.Activity}</Col> 
            <Col sm={3} ><Clickable value={item?.Element} text={item?.Element} onClick={onElement} /></Col>    
            </Row>
            <Row className="align-items-center" style={{fontSize: '0.8rem'}}>
            <Col sm={4} title='Date' >{item.Date}</Col>
            <Col sm={4}  title='Start'>{item.StartDate}</Col>
            <Col sm={4}  title='End'>{item.EndDate}</Col>
            </Row>
        </Col> 
    )

}

const Focusing = (element, activity, onReported) => {
    const [duration, Duration] = useState(0)
    const [reported, Reported] = useState(3)

    useEffect(() => {
        if(element>0 && activity>0) {
            let number=29
            const timer = setTimeout(function() {
                //console.log("duration reported : ", duration, reported)   
                Duration(duration + 1)
                if(reported===duration)
                {
                    const data = {
                        ActivityId: activity,
                        ElementId: element,
                        Focused: duration*number
                    }
                    //alert(`timer ${element} ${activity} ${data.Focused}`)
                    Fetch(`Timer`, data, 1)
                    Duration(0)

                    let random=Math.floor(Math.random() * 5)+1
                    Reported(random)
                    onReported && onReported(random)
                }
            }, number*1000)
        
            return () => { // this should work flawlessly besides some milliseconds lost here and there 
               clearTimeout(timer)
            }   
        }         
    }, [duration]);
}

const Delay = ms => new Promise(res => setTimeout(res, ms))

export {Timers, Focusing, Delay} 
